import type { FC } from "react";
import { Box } from '@hanzo/ui'

export interface LinkToProps {
  title: string;
  link: string;
}

export const LinkTo: FC<LinkToProps> = (props) => {
  const { title, link } = props;

  return (
    <Box className="flex flex-row gap-2">
      <Box tag="a" href={link} target="_blank" className="text-white text-base lg:text-[24px] 2xl:text-[32px]">{title}</Box>
      <img src="assets/common/linkto.svg" alt="linkto" />
    </Box>
  )
};